import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { MentionsBudgetDynamiques } from '@components/mentions-budget-dynamiques/models';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { BudgetEstimatorStore } from '@stores';

@Component({
  selector: 'app-mentions-budget-dynamiques',
  imports: [HandleHtmlLinksDirective],
  templateUrl: './mentions-budget-dynamiques.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MentionsBudgetDynamiquesComponent extends AbstractDynamicComponent<MentionsBudgetDynamiques> {
  readonly currentEstimate = inject(BudgetEstimatorStore).select('currentEstimate');
}
